// tblBankTransactionMethod
export enum BankTransactionMethod {
	CREDIT_CARD_DIRECT_DEBIT = 'CREDIT CARD - DIRECT DEBIT',
	DIRECT_DEBIT = 'Direct Debit',
	CREDIT_CARD = 'Credit Card',
	BPAY = 'BPAY',
}
